/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface AssetAccountResponse
 */
export interface AssetAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetAccountResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountResponse
     */
    bankName: string | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof AssetAccountResponse
     */
    address: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountResponse
     */
    iban: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountResponse
     */
    incomings: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAccountResponse
     */
    isOverdrawn: boolean | null;
}

/**
 * Check if a given object implements the AssetAccountResponse interface.
 */
export function instanceOfAssetAccountResponse(value: object): value is AssetAccountResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('bankName' in value) || value['bankName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('incomings' in value) || value['incomings'] === undefined) return false;
    if (!('isOverdrawn' in value) || value['isOverdrawn'] === undefined) return false;
    return true;
}

export function AssetAccountResponseFromJSON(json: any): AssetAccountResponse {
    return AssetAccountResponseFromJSONTyped(json, false);
}

export function AssetAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'bankName': json['bankName'],
        'address': AddressDtoFromJSON(json['address']),
        'iban': json['iban'],
        'incomings': json['incomings'],
        'isOverdrawn': json['isOverdrawn'],
    };
}

export function AssetAccountResponseToJSON(json: any): AssetAccountResponse {
    return AssetAccountResponseToJSONTyped(json, false);
}

export function AssetAccountResponseToJSONTyped(value?: AssetAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'bankName': value['bankName'],
        'address': AddressDtoToJSON(value['address']),
        'iban': value['iban'],
        'incomings': value['incomings'],
        'isOverdrawn': value['isOverdrawn'],
    };
}

